import React, { useState } from 'react';
import { FaBroom } from 'react-icons/fa';
import './UserSubscriptionManagementModal.css';

function UserSubscriptionManagementModal({ 
  plans, 
  subscriptions, 
  employees, 
  onClose, 
  onChangeUserPlan, 
  onAssignPlan, 
  onCleanupOrphaned 
}) {
  const [activeTab, setActiveTab] = useState('current');
  const [searchTerm, setSearchTerm] = useState('');

  // Get employees without subscriptions
  const getEmployeesWithoutPlans = () => {
    const employeesWithPlans = subscriptions.map(sub => sub.employee_id);
    return employees.filter(emp => !employeesWithPlans.includes(emp.id));
  };

  // Filter subscriptions based on search
  const filteredSubscriptions = subscriptions.filter(sub => {
    const searchLower = searchTerm.toLowerCase();
    return (
      sub.employee?.name?.toLowerCase().includes(searchLower) ||
      sub.employee?.email?.toLowerCase().includes(searchLower) ||
      sub.plan_name?.toLowerCase().includes(searchLower)
    );
  });

  // Filter employees without plans based on search
  const filteredEmployeesWithoutPlans = getEmployeesWithoutPlans().filter(emp => {
    const searchLower = searchTerm.toLowerCase();
    return (
      emp.name?.toLowerCase().includes(searchLower) ||
      emp.email?.toLowerCase().includes(searchLower) ||
      emp.department?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content user-management-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>User Subscription Management</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search users by name, email, or plan..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="tabs">
            <button
              className={`tab ${activeTab === 'current' ? 'active' : ''}`}
              onClick={() => setActiveTab('current')}
            >
              Current Subscriptions ({subscriptions.length})
            </button>
            <button
              className={`tab ${activeTab === 'unassigned' ? 'active' : ''}`}
              onClick={() => setActiveTab('unassigned')}
            >
              Users Without Plans ({getEmployeesWithoutPlans().length})
            </button>
          </div>

          {activeTab === 'current' && (
            <div className="tab-content">
              <div className="action-bar">
                <button
                  className="btn btn-warning"
                  onClick={onCleanupOrphaned}
                  title="Clean up subscriptions for deleted users"
                >
                  <FaBroom /> Cleanup Orphaned
                </button>
              </div>

              <div className="table-container">
                <table className="subscription-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Email</th>
                      <th>Current Plan</th>
                      <th>Status</th>
                      <th>Start Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSubscriptions.map(subscription => (
                      <tr key={subscription.id}>
                        <td>
                          {subscription.employee?.name || `Unknown User (ID: ${subscription.employee_id})`}
                        </td>
                        <td>
                          {subscription.employee?.email || `employee_id_${subscription.employee_id}@missing.com`}
                        </td>
                        <td>{subscription.plan_name || 'No Plan'}</td>
                        <td>
                          <span className={`status-badge ${subscription.status}`}>
                            {subscription.status}
                          </span>
                        </td>
                        <td>
                          {subscription.start_date ? new Date(subscription.start_date).toLocaleDateString() : 'N/A'}
                        </td>
                        <td>
                          <select
                            value={subscription.plan_definition_id}
                            onChange={(e) => onChangeUserPlan(subscription.employee_id, parseInt(e.target.value))}
                            className="plan-select"
                          >
                            {plans.filter(plan => plan.is_active).map(plan => (
                              <option key={plan.id} value={plan.id}>
                                {plan.name} - {parseFloat(plan.price_monthly) === 0 ? 'Free' : `$${plan.price_monthly}/month`}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'unassigned' && (
            <div className="tab-content">
              {filteredEmployeesWithoutPlans.length === 0 ? (
                <div className="empty-state">
                  <p>All users have been assigned plans! 🎉</p>
                </div>
              ) : (
                <div className="table-container">
                  <table className="subscription-table">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Department</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredEmployeesWithoutPlans.map(employee => (
                        <tr key={employee.id}>
                          <td>{employee.name}</td>
                          <td>{employee.email}</td>
                          <td>{employee.role || 'N/A'}</td>
                          <td>{employee.department || 'N/A'}</td>
                          <td>
                            <select
                              defaultValue=""
                              onChange={(e) => {
                                if (e.target.value) {
                                  onAssignPlan(employee.id, parseInt(e.target.value));
                                  e.target.value = "";
                                }
                              }}
                              className="plan-select"
                            >
                              <option value="" disabled>Assign Plan...</option>
                              {plans.filter(plan => plan.is_active).map(plan => (
                                <option key={plan.id} value={plan.id}>
                                  {plan.name} - {parseFloat(plan.price_monthly) === 0 ? 'Free' : `$${plan.price_monthly}/month`}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserSubscriptionManagementModal;